import React from "react";
import { graphql } from "gatsby";
import styled from "styled-components";
import {
  BlockContent,
  ContactDetails,
  GraphQLErrorList,
  SEO,
  ResponsiveTitle1,
  ContactForm,
} from "../components";

import Layout from "../containers";

export const query = graphql`
  query ContactPageQuery {
    page: sanityContact(_id: { regex: "/(drafts.|)contact/" }) {
      title
      _rawBody
    }
    contactInfo: sanityContactInfo(_id: { regex: "/(drafts.|)contactInfo/" }) {
      name
      address1
      address2
      postCode
      city
      county
      contactNumber
      email
    }
  }
`;

const Container = styled.div`
  padding: 0 1.5em;
`;

const ContactPage = (props) => {
  const { data, errors } = props;

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    );
  }

  const { page } = data;
  const { contactInfo } = data;

  if (!page) {
    throw new Error(
      'Missing "Contact" page data. Open the studio at http://localhost:3333 and add "Contact" page data and restart the development server.'
    );
  }

  if (!contactInfo) {
    throw new Error(
      "Missing CompanyInfo page data. Open the studio at http://localhost:3333 and add CompanyInfo page data and restart the development server."
    );
  }

  return (
    <Layout>
      <SEO title={page.title} />
      <Container>
        <ResponsiveTitle1>{page.title}</ResponsiveTitle1>
        <ContactDetails contactInfo={contactInfo} />
        <div>
          Email: <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
        </div>
        <ContactForm />
        <BlockContent blocks={page._rawBody || []} />
      </Container>
    </Layout>
  );
};
ContactPage.defaultProps = {
  data: {
    page: {
      title: "No title",
    },
  },
};
export default ContactPage;
